import { useRef } from 'react';

import cn from 'classnames';

import { IconComponent } from 'components/Icon/IconComponent';
import { IconButton } from 'components/IconButton/IconButton';
import StatusPill from 'components/Pills/StatusPills';

import { useClickOutside } from '../../hooks/click-outside';
import styles from './AnimatedModal.module.scss';

export const AnimatedModal = ({
  visible,
  children,
  className,
  title,
  description,
  icon,
  noClose = false,
  customActions = [],
  onClose = () => {},
  status,
  small = false,
  fullscreen = false,
  oldIconLibrary = true,
}) => {
  const wrapperRef = useRef(null);

  useClickOutside(wrapperRef, onClose);

  return (
    <div className={cn(styles.root, { [styles.rootVisible]: visible })}>
      <div
        className={cn(styles.contentWrapper, {
          [styles.contentWrapperSmall]: small,
          [styles.contentWrapperFullscreen]: fullscreen,
        })}
        ref={wrapperRef}>
        <div
          className={cn(
            styles.header,
            'd-flex',
            'justify-content-between',
            'align-items-start',
            'u-margin-y',
          )}>
          <div
            className={cn(
              styles.headerContent,
              'd-flex',
              'align-items-start',
              'u-margin-right--large',
            )}>
            {icon && (
              <div className="u-margin-right">
                <IconComponent icon={icon} oldIconLibrary={oldIconLibrary} />
              </div>
            )}
            <div className="d-flex flex-column align-items-start">
              <div className="d-flex align-items-center u-gap-medium">
                {title && (
                  <span className={cn(styles.title, 'primary-text u-capitalize u-font-weight-500')}>
                    {title}
                  </span>
                )}
                {status && (
                  <StatusPill text={status.text} status={status.status} className={styles.status} />
                )}
              </div>
              {description && (
                <p
                  className="u-font-weight-400 secondary-text"
                  dangerouslySetInnerHTML={{ __html: description }}
                />
              )}
            </div>
          </div>
          <div className="d-flex align-items-center u-gap">
            {(customActions || []).map((action, index) => {
              return (
                <IconButton
                  key={action.text + index}
                  icon={action.icon}
                  onClick={action.onClick}
                  tip={action.text}
                  prefix="hugeicons"
                />
              );
            })}
            {!noClose && <IconButton icon="x" onClick={onClose} tip="Close" />}
          </div>
        </div>
        <div className={cn({ [className]: className })}>{children}</div>
      </div>
    </div>
  );
};
